import React, { useContext, useState, useEffect } from 'react';
import './AddLocationPopup.css';
import cn from "classnames";
import styles from './AddLocationPopup.module.sass';
// import ThumbsUp from '../GetQuote/FormSection/Images/thumbsUp.png';
import Modal from '@mui/material/Modal';
import Card from '../../../../components/Card';
import { GlobalState } from '../../../../App';
import TextInput from '../../../../components/TextInput';
import { getLocationDocId, validate_if_not_empty } from '../../../../utils/extensions';
import Icon from '../../../../components/Icon';


const AddLocationPopup = () => {
  const { setIsClickedSave, locationsList, setLocationsList, setShowLocationPopup,
    activeEditLocation, setActiveEditLocation,
    showModalViewLocation, setShowModalViewLocation,
  } = useContext(GlobalState)

  useEffect(() => {
    setIsClickedSave(false)
  }, [])

  const handleClose = () => {
    setShowModalViewLocation(false);
  }

  useEffect(() => {
    if (activeEditLocation) {
      setLocationTitle(activeEditLocation?.title)
      setLocationTitleAr(activeEditLocation?.titleAr)
    }
  }, [activeEditLocation])

  const [locationTitleAr, setLocationTitleAr] = useState()
  const [locationTitle, setLocationTitle] = useState()

  const locationDetailsObj = {
    id: getLocationDocId(),
    title: '',
    titleAr: '',
    dateCreated: '',
    dateEdited: ''
  }

  const createLocation = async () => {
    locationDetailsObj.title = locationTitle;
    locationDetailsObj.titleAr = locationTitleAr;
    await setLocationsList((oldData) => [...oldData, locationDetailsObj])
    setIsClickedSave(true)
    setShowLocationPopup(false)
  }

  const updateLocation = async () => {
    for (let index = 0; index < locationsList.length; index++) {
      if (locationsList[index]?.id === activeEditLocation?.id) {
        locationsList[index].title = locationTitle;
        locationsList[index].titleAr = locationTitleAr;

        setActiveEditLocation()
        setIsClickedSave(true)
        setShowLocationPopup(false)
      }

    }

  }

  return (
    <Modal
      disableAutoFocus={true}
      open={showModalViewLocation}
      onClose={handleClose}
      className='dialog-wrapper'
      sx={{
        outline: '0 !important',
        border: 'none !important'
      }}
    >
      <Card
        className={cn(styles.card)}
        title="Add location"
        classTitle="title-green"
        classCardHead={styles.cardHead}
        head={
          <div style={{
            display: 'flex',
            gap: '12px'
          }}>

            <button
              onClick={() => {
                if (validate_if_not_empty(locationTitle, "locationTitlePopupErrId") &&
                  validate_if_not_empty(locationTitleAr, "locationTitleArPopupErrId")) {
                  activeEditLocation ? updateLocation() :
                    createLocation()
                }
              }}
              className={cn("button", styles.button)} >
              <span>Save</span>
            </button>
            <button
              onClick={() => {
                setShowModalViewLocation(false)
              }}
              className={cn(styles.closeButton)} >
              <Icon name="close" fill="red" size="16" />
            </button>
          </div>

        }
      >
        <div className={cn(styles.fieldContainer, styles.titleEnFieldContainer)}>
          <TextInput
            className={styles.field}
            classInput={styles.fieldInput}
            label="Title"
            name="popupLocationTitle"
            type="title"
            onChange={(e) => { setLocationTitle(e.target.value) }}
            value={locationTitle}
            required
          />
          <p className={styles.errField} id="locationTitlePopupErrId"></p>
        </div>

        <div className={styles.fieldContainer}>
          <TextInput
            className={styles.field}
            classInput={styles.fieldInput}
            label="TitleAr"
            name="popupLocationTitleAr"
            type="titleAr"
            onChange={(e) => { setLocationTitleAr(e.target.value) }}
            value={locationTitleAr}
            required
          />
          <p className={styles.errField} id="locationTitleArPopupErrId"></p>
        </div>
      </Card>

    </Modal>

  )
}

export default AddLocationPopup